(() => {
  const widgetLoader = 'https://integrations.etrusted.com/applications/widget.js/v2';
  if (!customElements.get('etrusted-widget') && !Array.from(document.scripts).some(script => script.src === widgetLoader)) {
    const script = document.createElement('script');
    script.src = widgetLoader;
    script.async = true;
    document.head.append(script);
  }

  const requests = new Map();
  const matches = new Map();
  const read = url => {
    if (!requests.has(url)) requests.set(url, (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch(url, { credentials: 'omit', signal: controller.signal });
        if (!response.ok) throw new Error('Review feed unavailable');
        return await response.json();
      } finally { clearTimeout(timeout); }
    })());
    return requests.get(url);
  };
  const encodeSku = value => Array.from(new TextEncoder().encode(value), byte => byte.toString(16).padStart(2, '0')).join('');
  const productReviewMatch = (widget, identifiers, type) => {
    const key = JSON.stringify([widget, type, identifiers]);
    if (!matches.has(key)) matches.set(key, (async () => {
      if (!identifiers.length) return false;
      const manifest = await read(`https://integrations.etrusted.com/manifests/v1/${widget}.json`);
      const gradeTemplate = manifest.dynamicFeeds?.grades?.url;
      if (!gradeTemplate) return false;
      let skus = identifiers;
      if (type !== 'sku') {
        const productTemplate = manifest.dynamicFeeds?.products?.url;
        if (!productTemplate) return false;
        const products = await Promise.all(identifiers.map(identifier => read(productTemplate.replace('$_PRODUCT_IDENTIFIER_TYPE', type).replace('$_PRODUCT_IDENTIFIER', encodeURIComponent(identifier))).catch(() => [])));
        skus = products.flat().map(product => product.sku).filter(Boolean);
      }
      const results = await Promise.all([...new Set(skus)].map(async sku => {
        try {
          // Use the same public per-product grade feed and UTF-8 SKU encoding as the official widget.
          const url = gradeTemplate.replace('$_PRODUCT_IDENTIFIER_TYPE', 'sku').replace('$_PRODUCT_IDENTIFIER', encodeSku(sku));
          const feed = await read(url);
          const count = feed.grades?.overall?.count;
          return Number.isInteger(count) && count > 0;
        } catch { return false; }
      }));
      return results.some(Boolean);
    })().catch(() => false));
    return matches.get(key);
  };

  if (!customElements.get('ge-product-review-switch')) customElements.define('ge-product-review-switch', class extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      let identifiers;
      try { identifiers = JSON.parse(this.dataset.identifiers || '[]').filter(value => typeof value === 'string' && value.trim()); }
      catch { identifiers = []; }
      const hasReviews = await productReviewMatch(this.dataset.widgetId, identifiers, this.dataset.identifierType);
      if (!this.isConnected) { this.initialized = false; return; }
      this.dataset.reviewSource = hasReviews ? 'product' : 'shop';
      if (!hasReviews) return;
      const productContent = this.querySelector('[data-product-reviews]');
      const template = this.querySelector('template');
      if (template) productContent.append(template.content.cloneNode(true));
      productContent.hidden = false;
      this.querySelector('[data-review-fallback]').hidden = true;
    }
  });

  if (!customElements.get('ge-review-grid-strip')) customElements.define('ge-review-grid-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.place = () => {
        const grid = this.parentElement;
        if (!grid) return;
        const cards = Array.from(grid.children).filter(child => child.matches('product-card'));
        const columns = Math.max(1, parseInt(getComputedStyle(grid).getPropertyValue('--product-list-items-per-row'), 10) || 1);
        const target = cards[Math.min(columns, cards.length) - 1];
        if (target && target.nextElementSibling !== this) target.after(this);
      };
      this.observer = new ResizeObserver(() => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(this.place); });
      this.observer.observe(this.parentElement);
      this.frame = requestAnimationFrame(this.place);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.observer = null; cancelAnimationFrame(this.frame); }
  });
})();
